import { Form, Formik, useFormik } from 'formik'
import React from 'react'
import { useMutation } from '@tanstack/react-query'
// import FileSelectInput from './FileSelectInput'
import * as Yup from 'yup'
import { Modal2 } from './Modal'
import { SAMPLE_UPLOAD_FILE_LINKS } from '../consts'
import { useTranslation } from 'react-i18next'
import { uploadFile, import_data, CFieldProps } from '@velocity/shared'
import { CFields } from './form/Form'

type Props = {
  open: string
  setOpen: (val: any) => void
  model: string
  title: string
}
export function ImportData({ open, setOpen, model, title }: Props) {
  const { t } = useTranslation()
  const mutation = useMutation({
    mutationFn: import_data,
    onSuccess: () => {
      setOpen(false)
      formik.resetForm()
    }
  })
  const initialValues: any = { model, media: '' }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: async (values) => {
      let v = { ...values }
      if (v.media) {
        const res = await uploadFile(values.media, 'import/' + model)
        if (res.status) v.media = res.data
        else delete v.media
      }
      mutation.mutate(v)
    },
    validationSchema: Yup.object({
      media: Yup.mixed().required().label('File')
    })
  })

  const fields: CFieldProps[] = [
    {
      name: 'media',
      label: 'File',
      type: 'file'
    }
  ]
  if (model === 'users') {
    fields.push({
      name: 'role_id',
      label: 'Role',
      type: 'select',
      optionsQuery: {
        queryKey: [
          'role',
          { sort_field: 'name', sort_order: 'asc', filter: { status: true } }
        ],
        enabled: true,
        search: true
      },
      initialValue: '',
      helpText:
        'Only applies to new users. Existing users will retain their current role.'
    })
    fields.push({
      name: 'send_invitation_email',
      label: 'Send Invitation Email',
      type: 'switch',
      initialValue: true,
      helpText:
        'If checked, an invitation email will be sent to new users after import.'
    })
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={Yup.object({
        media: Yup.mixed().required().label('File')
      })}
      onSubmit={async (values) => {
        let v = { ...values }
        if (v.media) {
          const res = await uploadFile(values.media, 'import/' + model)
          if (res.status) v.media = res.data
          else delete v.media
        }
        mutation.mutate(v)
      }}
    >
      {({ handleSubmit }) => {
        const buttons = [
          {
            title: 'Upload',
            loading: mutation.isPending,
            type: 'submit',
            onClick: handleSubmit
          },
          {
            title: 'Cancel',
            onClick: () => setOpen(false),
            btnStyle: 'outline'
          }
        ]
        return (
          <Modal2
            open={open === 'import'}
            setOpen={setOpen}
            title={t(open + ' ' + title + 's').toUpperCase()}
            buttons={buttons}
          >
            <Form className='grid grid-cols-1 gap-2'>
              <CFields fields={fields} />
            </Form>
            <form onSubmit={formik.handleSubmit}>
              <div className='grid-cols-2 gap-4 sm:grid'>
                {/* <FileSelectInput
            meta={formik.getFieldMeta('media')}
            name='media'
            label='Upload CSV File'
            onChange={(file: any) => formik.setFieldValue('media', file)}
            accept='.csv'
          /> */}
                <div className='text-sm'>
                  <a
                    className='text-primary text-lg'
                    href={SAMPLE_UPLOAD_FILE_LINKS[model]}
                    download={true}
                  >
                    {t('Download Sample File')}
                  </a>
                  <ul>
                    <li>{t('Download the sample file and fill the data')}</li>
                    <li>{t('Do not change the column headers')}</li>
                  </ul>
                </div>
              </div>
            </form>
          </Modal2>
        )
      }}
    </Formik>
  )
}
